<div class="layout-row-wrap card-content">
  <div class="flex-50 mat-body-strong">
    {{ 'labels.inputs.Payment Type' | translate }}
  </div>

  <div class="flex-50">
    {{ paymentDetailData.paymentType.name }}
  </div>
</div>
@if (hasSomeValue()) {
  <table>
    <tbody>
      <tr>
        <td class="mat-body-strong center" colspan="2">{{ 'labels.inputs.Payment Details' | translate }}</td>
      </tr>
      @if (isNotNullOrEmpty(paymentDetailData.accountNumber)) {
        <tr>
          <td class="mat-body-strong">{{ 'labels.inputs.Account No' | translate }}</td>
          <td>{{ paymentDetailData.accountNumber }}</td>
        </tr>
      }
      @if (isNotNullOrEmpty(paymentDetailData.checkNumber)) {
        <tr>
          <td class="mat-body-strong">{{ 'labels.inputs.Cheque Number' | translate }}</td>
          <td>{{ paymentDetailData.checkNumber }}</td>
        </tr>
      }
      @if (isNotNullOrEmpty(paymentDetailData.routingCode)) {
        <tr>
          <td class="mat-body-strong">{{ 'labels.inputs.Routing Code' | translate }}</td>
          <td class="mat-body-strong">{{ paymentDetailData.routingCode }}</td>
        </tr>
      }
      @if (isNotNullOrEmpty(paymentDetailData.receiptNumber)) {
        <tr>
          <td class="mat-body-strong">{{ 'labels.inputs.Receipt No' | translate }}</td>
          <td>{{ paymentDetailData.receiptNumber }}</td>
        </tr>
      }
      @if (isNotNullOrEmpty(paymentDetailData.bankNumber)) {
        <tr>
          <td class="mat-body-strong">{{ 'labels.inputs.Bank No' | translate }}</td>
          <td>{{ paymentDetailData.bankNumber }}</td>
        </tr>
      }
    </tbody>
  </table>
}
